import axios from 'axios';
import {useQuery, useQueryClient} from 'react-query';
import {environment} from '../config/environment';
import {latestBlockState} from '../state';
import {useRecoilValue} from 'recoil';

export const useLatestBlocks = () => {
    const recoilLatestBlock = useRecoilValue(latestBlockState)
    const queryClient = useQueryClient();

    return useQuery(
        'latest-blocks',
        () => axios.get(`${environment.apiBase}/block/list?count=10`).then((res) => res.data),
        {
            retry: false,
            staleTime: 1000 * 60,
            refetchInterval: 1000 * 60,
            onSuccess: (data) => {
                // Update block
                Object.keys(data.payload).forEach((i) => {
                    const r = {type: 'block', payload: data.payload[i]};
                    queryClient.setQueryData(['block', data.payload[i].height], r);
                    queryClient.setQueryData(['block', '0x' + data.payload[i].hash], r);
                });

                // invalidate summary
                const latestBlock = data.payload.at(0); // assuming sorted
                if (recoilLatestBlock.height === -1 || latestBlock.height > recoilLatestBlock.height) {
                    queryClient.invalidateQueries({queryKey:'summary'})
                }
            },
        }
    );
};

export default useLatestBlocks;
